import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { formatDate } from '@angular/common';
import * as FileSaver from 'file-saver';
import { TicketService } from './ticket.service';
import { TicketModel } from './ticket.model';
import { TicketFilterModel } from './ticketFilter.model';
import { Utils } from '../../../shared/utils';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';

export interface TicketTotalDialogData {
    activityUid: string;
    fromDate?: Date;
    toDate?: Date;
}

@Component({
    selector: 'convfact-tickettotal',
    templateUrl: './ticket-dialog-total.component.html',
    styleUrls: ['./ticket-dialog-total.component.css'],
    standalone: false
})
export class TicketDialogTotalComponent {
    model = new TicketFilterModel();
    submitted = false;
    busy = false;
    exporting = false;
    result = false;

    tickets: TicketModel[] = [];
    total = 0;
    paided = 0;

    static open(dialog: MatDialog, data: TicketTotalDialogData): Observable<void> {
        return dialog.open(TicketDialogTotalComponent, {
            width: '760px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            autoFocus: false,
            data,
        }).afterClosed();
    }

    constructor(
        public dialogRef: MatDialogRef<TicketDialogTotalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TicketTotalDialogData,
        private ticketService: TicketService,
        private notify: NotificationService,
    ) {
        const today = new Date();
        this.model.fromDate = data.fromDate || new Date(today.getFullYear(), today.getMonth(), 1);
        this.model.toDate = data.toDate || today;
    }

    calculate(): void {
        this.submitted = true;
        if (!this.model.fromDate || !this.model.toDate) return;

        this.setBusy(true);
        this.ticketService.getListFilter(this.data.activityUid, {
            fromDate: formatDate(this.model.fromDate, 'yyyy-MM-dd', 'es-ES'),
            toDate: formatDate(this.model.toDate, 'yyyy-MM-dd', 'es-ES'),
        } as any)
            .then(tickets => {
                this.tickets = tickets || [];
                this.total = Utils.GetValueWithDecimals(this.tickets.reduce((sum, t) => sum + (t.total || 0), 0));
                this.paided = Utils.GetValueWithDecimals(this.tickets.filter(t => !!t.paided).reduce((sum, t) => sum + (t.total || 0), 0));
                this.result = true;
            })
            .catch(() => this.notify.error('No se pudieron totalizar las facturas simplificadas'))
            .then(() => this.setBusy(false));
    }

    export(): void {
        this.exporting = true;
        this.setBusy(true);
        this.ticketService.export(this.tickets.map(t => t.uid))
            .then(blob => {
                FileSaver.saveAs(blob, Utils.GetExcelName('Tickets_Totalizar'));
                this.notify.ok(`Excel generado con ${this.tickets.length} ${this.tickets.length === 1 ? 'factura simplificada' : 'facturas simplificadas'}`);
            })
            .catch(() => this.notify.error('No se pudo generar el Excel'))
            .then(() => {
                this.exporting = false;
                this.setBusy(false);
            });
    }

    changeRange(): void {
        this.result = false;
        this.submitted = false;
    }

    closeDialog(): void {
        if (this.busy) return;
        this.dialogRef.close();
    }

    trackByUid(_: number, ticket: TicketModel): string {
        return ticket.uid;
    }

    private setBusy(busy: boolean): void {
        this.busy = busy;
        this.dialogRef.disableClose = busy;
    }
}
